import {injectable} from "tsyringe";
import {DeleteIssueTypeCommand} from "../commands/delete-issue-type.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {IssueType} from "../domain/entities/issue-type.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({source: DeleteIssueTypeCommand, target: `dto`})
export class DeleteIssueTypeCommandToDtoTransformer extends AbstractCommandToDtoTransformer<IssueType> {

    protected async toDTO(issueType: IssueType): Promise<DataTransferObject> {
        return Promise.resolve(<DataTransferObject>{uid: issueType.uid});
    }

}
